<template>
  <div class="report-doc">
    <div class="btn-toolbar">
      <div class="btn-group"></div>
    </div>

    <iframe :src="viewer" class="iframe" :id="'report-' + index" ref="pdfFrame"></iframe>
  </div>
</template>
<script>
import EventBus from "../../../event-bus";
import { PDF_VIEWER_ADDRESS } from "@/api/config";

export default {
  name: "report-doc",
  props: {
    report: null,
    index: {
      type: String,
      default: "",
    },
    id: Number,
  },
  data() {
    return {
      viewer: PDF_VIEWER_ADDRESS,
      iframe: Object,
      isChecked: false,
    };
  },
  computed: {
    pdfViewerFrame: function () {
      return this.$refs["pdfFrame"].contentWindow;
    },
  },
  mounted() {
    EventBus.on("refreshMessage", (event) => {
      if (this.report !== null) this.refreshData(this.report);
    });
  },
  beforeDestroy() {
    EventBus.off("refreshMessage");
    delete this.viewer;
    this.viewer = null;
    delete this.iframe;
    this.iframe = null;
    delete this.isChecked;
    this.isChecked = null;
    delete this.pdfViewerFrame;
  },
  methods: {
    refreshData(report) {
      if (report !== null) {
        this.pdfViewerFrame.postMessage({ pdf: report }, "*");
      }
    },
  },
  watch: {
    report(newPdf, old) {
      this.refreshData(newPdf);
    },
  },
};
</script>
<style scoped lang="scss">
.report-doc {
  width: 100%;
}

.iframe {
  width: 100% !important;
  height: 80vh;
  background-color: #fff;
  border: 1px solid lighten(#000, 70%);
}

.switch {
  margin-left: 0.5rem;
}

.btn-toolbar {
  background-image: url("../../../assets/images/texture.png"),
    linear-gradient(hsla(0, 0%, 32%, 0.99), hsla(0, 0%, 27%, 0.95));
  box-shadow: inset 1px 0 0 hsla(0, 0%, 100%, 0.08), inset 0 1px 1px hsla(0, 0%, 0%, 0.15),
    inset 0 -1px 0 hsla(0, 0%, 100%, 0.05), 0 1px 0 hsla(0, 0%, 0%, 0.15),
    0 1px 1px hsla(0, 0%, 0%, 0.1);

  .btn {
    color: #ffffff;
    border-right: 1px solid darken(#fff, 60%);

    &:hover {
      border: 1px solid lighten(#000, 20%);
      background-color: lighten(#000, 20%);
      color: #ffffff;
    }
  }

  .icon {
    color: #fff;
  }
}
.selected {
  background-color: lighten(#000, 20%);
}
</style>
